// extracted by mini-css-extract-plugin
export var brand = "_2i-9";
export var compact = "_2i-6";
export var extraSmall = "_2i-7";
export var icon = "_2i-0";
export var large = "_2i-4";
export var light = "_2i-1";
export var medium = "_2i-5";
export var outline = "_2i-b";
export var primaryDark = "_2i-a";
export var primaryLight = "_2i-8";
export var primaryModern = "_2i-c";
export var success = "_2i-2";
export var successSolid = "_2i-3";